(() => {
  const initStickyAddToCart = () => {
    document.querySelectorAll('[data-sticky-atc]:not([data-sticky-atc-ready])').forEach((bar) => {
      bar.setAttribute('data-sticky-atc-ready', 'true');

      const sectionId = bar.dataset.sectionId;
      const stickyButton = bar.querySelector('[data-sticky-atc-button]');
      const stickyButtonText = bar.querySelector('[data-sticky-atc-button-text]');
      const stickyPrice = bar.querySelector('[data-sticky-atc-price]');
      const stickyVariant = bar.querySelector('[data-sticky-atc-variant]');

      const originalButton =
        document.querySelector(`#ProductSubmitButton-${sectionId}`) ||
        document.querySelector(`#product-form-${sectionId} [name="add"]`) ||
        document.querySelector(`form[action*="/cart/add"] [name="add"]`) ||
        document.querySelector('product-form [name="add"]');

      const originalPrice =
        document.querySelector(`#price-${sectionId}`) ||
        document.querySelector('.product__info-container .price');

      const getVariantText = () => {
        const variantIdInput =
          document.querySelector(`#product-form-${sectionId} [name="id"]`) ||
          document.querySelector(`form[action*="/cart/add"] [name="id"]`);

        if (!variantIdInput) return '';

        const selectedOptionText = Array.from(
          document.querySelectorAll('variant-selects select, variant-radios input[type="radio"]:checked, variant-selects input[type="radio"]:checked')
        )
          .map((input) => {
            if (input.tagName === 'SELECT') {
              return input.options[input.selectedIndex]?.textContent?.trim();
            }

            return input.value?.trim();
          })
          .filter(Boolean)
          .join(' / ');

        return selectedOptionText;
      };

      if (!stickyButton || !originalButton) {
        return;
      }

      const setVisible = (visible) => {
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', String(!visible));
        document.documentElement.classList.toggle('sticky-atc-active', visible);

        stickyButton.setAttribute('tabindex', visible ? '0' : '-1');
      };

      const syncState = () => {
        const isDisabled =
          originalButton.disabled ||
          originalButton.getAttribute('aria-disabled') === 'true';

        stickyButton.disabled = isDisabled;
        stickyButton.setAttribute('aria-disabled', String(isDisabled));

        const originalText = originalButton.querySelector('span')?.textContent?.trim();

        if (originalText && stickyButtonText) {
          stickyButtonText.textContent = originalText;
        }

        if (originalPrice && stickyPrice) {
          stickyPrice.innerHTML = originalPrice.innerHTML;
        }

        if (stickyVariant) {
          const variantText = getVariantText();

          if (variantText && variantText !== 'Default Title') {
            stickyVariant.textContent = variantText;
            stickyVariant.hidden = false;
          } else {
            stickyVariant.textContent = '';
            stickyVariant.hidden = true;
          }
        }
      };

      const delayedSyncState = () => {
        window.setTimeout(syncState, 80);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            const originalButtonIsAboveViewport = entry.boundingClientRect.top < 0;
            const shouldShow =
              !entry.isIntersecting &&
              originalButtonIsAboveViewport &&
              window.scrollY > 300;

            setVisible(shouldShow);
          },
          {
            threshold: 0
          }
        );

        observer.observe(originalButton);
      } else {
        window.addEventListener(
          'scroll',
          () => {
            setVisible(window.scrollY > 600);
          },
          { passive: true }
        );
      }

      stickyButton.addEventListener('click', () => {
        syncState();

        if (!stickyButton.disabled) {
          originalButton.click();
        }
      });

      document.addEventListener('change', delayedSyncState);
      document.addEventListener('input', delayedSyncState);
      document.addEventListener('variant:change', delayedSyncState);

      const buttonObserver = new MutationObserver(syncState);

      buttonObserver.observe(originalButton, {
        attributes: true,
        childList: true,
        subtree: true
      });

      if (originalPrice) {
        const priceObserver = new MutationObserver(syncState);

        priceObserver.observe(originalPrice, {
          childList: true,
          subtree: true
        });
      }

      syncState();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAddToCart);
  } else {
    initStickyAddToCart();
  }

  document.addEventListener('shopify:section:load', initStickyAddToCart);
})();